import styled from 'styled-components';
import Input from 'components/ui/Input';

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;

  > button {
    margin: 0;
    margin-top: 8px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledLabel = styled.label`
  display: block;
  font-weight: bolder;
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
`;

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  flex: 1;
  margin-top: 8px;
`;

export const ErrorMessage = styled.span`
  font-size: 14px;
  color: red;
  display: block;
`;
